import { Box,Typography, createStyles, makeStyles, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { useUserProvider } from '../../providers/UserProvider';
import { DoneAll } from '@material-ui/icons';
import LoadMoreButton from './LoadMoreButton';
import { format } from 'date-fns';
import { useMfwThemeProvider } from 'myfitworld-utils';
import { ProviderThemeType } from 'myfitworld-utils/dist/types/ThemeTypes';
import getLocalizedProperty from 'src/utils/getLocalizedProperty';
import ReactionImage from '../ReactionImage';
import { useIntl } from 'react-intl';
import chatMessages from './messages';
import { ChatMessage } from 'myfitworld-model';
import {linkify} from "../../utils/renderTextWithLinks";

const createStylesForTheme = (theme: ProviderThemeType, isMobile: boolean) =>
  makeStyles(() =>
    createStyles({
        incomingMessageBox: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            backgroundColor: theme.theme.backgroundColor.light,
            width: isMobile ? '80%' : '30%',
            marginBottom: '1%',
            padding: '1%',
            borderRadius: 5,
        },
        sendingMessageBox:{
            display:'flex',
            flexDirection:'column',
            marginBottom: '2%',
            backgroundColor: theme.theme.primary,
            padding:'1%', 
            alignItems:"end",
        },
        messageText: {
            fontSize: 15, 
            whiteSpace: 'pre-wrap', 
            wordWrap: 'break-word'
        },
        replyMessageBox: {
            backgroundColor: theme.theme.backgroundColor.light,
            borderRadius: '5px 5px 0 0',
            border: '1px solid',
            borderColor: theme.theme.primary,
            padding: '1%'
        },
        replyMessageBoxText: {
            fontSize: 13
        },
        borderRadiusWhenReply: {
            borderRadius: '0 0 5px 5px'
        },
        createdAtText: {
            fontSize: 10,
            marginRight: 2
        }
    })
  );

const getTime = (dateTime: Date) => { return format(dateTime, "dd/MM/yyyy HH:mm");}

const MessagesView = ({userId, messages, hasMore, fetchMoreMessages} : MessagesViewProps) => {
    const {user} = useUserProvider();

    return(
        <Box>
            {hasMore &&  <LoadMoreButton onPress={fetchMoreMessages} />}
            {messages.map((message: ChatMessage) =>  
                (
                    <>
                        {message.senderId === user?.id && 
                            <AuthUserMessage message={message}/>
                        }
                        {message.senderId === userId && 
                            <UserMessage message={message}/>
                        }
                    </>
                )
            )} 
        </Box>
    );
};
export default MessagesView;

interface MessagesViewProps {
    userId: string;
    messages: ChatMessage[];
    hasMore: boolean;
    fetchMoreMessages: () => void;
}

const AuthUserMessage = ({message}: {message: ChatMessage}) => {
    const {formatMessage, locale} = useIntl();
    const {mfwMobTheme, mfwMuiWebTheme, theme} = useMfwThemeProvider();
    const isMobile = useMediaQuery(mfwMuiWebTheme.breakpoints.down('sm'));
    const useStyles = createStylesForTheme(theme, isMobile);
    const classes = useStyles();
    const WORKOUT_TITLE_LENGTH = isMobile ? 50 : 70;

    return (
        <Box display='flex' justifyContent='flex-end' key={message.id}>
            <Box flexDirection={'column'} width={ isMobile ? '80%' : '30%'}>
                {message.replyOnWorkoutFeedbackData && 
                    <Box className={classes.replyMessageBox}>
                        <Box display='flex' flexDirection='column' justifyContent='space-between'>
                            <Box display='flex' flexDirection='row'>
                                { message.replyOnWorkoutFeedbackData.reaction && <ReactionImage reaction={message.replyOnWorkoutFeedbackData.reaction} smallSize={true}/>}
                                <Typography variant="h5" style={{marginLeft: 5}} className={classes.replyMessageBoxText}>{formatMessage(chatMessages.workout_completed).toUpperCase()}</Typography>
                            </Box>
                            {message.replyOnWorkoutFeedbackData?.workout?.title &&
                                <Typography className={classes.replyMessageBoxText}>{getLocalizedProperty(locale, message.replyOnWorkoutFeedbackData.workout?.title).length > WORKOUT_TITLE_LENGTH ? `${getLocalizedProperty(locale, message.replyOnWorkoutFeedbackData?.workout?.title).slice(0, WORKOUT_TITLE_LENGTH)}...` : getLocalizedProperty(locale, message.replyOnWorkoutFeedbackData?.workout?.title)}</Typography>
                            }
                        </Box>
                        <Typography className={classes.replyMessageBoxText}>{message.replyOnWorkoutFeedbackData.text}</Typography>
                    </Box>
                }
                <Box className={classes.sendingMessageBox} borderRadius={message.replyOnWorkoutFeedbackData ? '0 0 5px 5px' : 5}>
                  <Typography
                    className={classes.messageText}
                    component="div"
                    dangerouslySetInnerHTML={{ __html: linkify(message.text, theme.theme.secondary) }}
                  />
                    <Box flexDirection={'row'} display='flex' justifyContent='flex-end'>
                        <Typography className={classes.createdAtText}>{getTime(message.createdAt)}</Typography>
                        <DoneAll style={{fontSize: 15, fill: message.read ? mfwMobTheme.text : mfwMobTheme.text300}}/>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
};

const UserMessage = ({message}: {message: ChatMessage}) => {
    const theme = useMfwThemeProvider();
    const isMobile = useMediaQuery(theme.mfwMuiWebTheme.breakpoints.down('sm'));
    const useStyles = createStylesForTheme(theme.theme, isMobile);
    const classes = useStyles();

    return (
        <Box className={classes.incomingMessageBox} key={message.id}>
          <Typography
            className={classes.messageText}
            component="div"
            dangerouslySetInnerHTML={{ __html: linkify(message.text, theme.theme.theme.primary) }}
          />
            <Typography className={classes.createdAtText}>{getTime(message.createdAt)}</Typography>
        </Box>
    );
}
